import { render, staticRenderFns } from "./ShareCampaign.vue?vue&type=template&id=28500892&"
import script from "./ShareCampaign.vue?vue&type=script&lang=ts&"
export * from "./ShareCampaign.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports